document.addEventListener('DOMContentLoaded', function() {
  const bannerSliders = document.querySelectorAll('.collection-banner-wrapper.swiper');
  if (!bannerSliders.length) return;
  
  bannerSliders.forEach(slider => {
    const sectionId = slider.closest('[id^="banner-list-"]').id;
    const section = document.getElementById(sectionId);
    const blockGap = parseInt(slider.getAttribute('data-block-gap') || 20);
    const autoPlay = slider.hasAttribute('data-auto-play');
    const autoPlayInterval = parseInt(slider.getAttribute('data-auto-play-interval') || 5);
    
    const swiperOptions = {
      slidesPerView: 1,
      spaceBetween: blockGap,
      loop: true,
      pagination: {
        el: `#${sectionId} .swiper-pagination`,
        clickable: true
      },
      navigation: {
        nextEl: `#${sectionId} .swiper-button-next`,
        prevEl: `#${sectionId} .swiper-button-prev`
      },
      breakpoints: {
        320: {
          slidesPerView: 1,
          spaceBetween: blockGap
        },
        480: {
          slidesPerView: 1,
          spaceBetween: blockGap
        },
        768: {
          slidesPerView: 1,
          spaceBetween: blockGap
        },
        1024: {
          slidesPerView: 1,
          spaceBetween: blockGap
        }
      }
    };
    
    if (autoPlay) {
      swiperOptions.autoplay = {
        delay: autoPlayInterval * 1000,
        disableOnInteraction: false
      };
    }
    
    new Swiper(slider, swiperOptions);
  });
});

document.addEventListener('DOMContentLoaded', function () {
  new Swiper(".mySwiper", {
    loop: true,
    slidesPerView: 1,
    spaceBetween: 0,
    autoplay: false,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });
});